<style lang="scss" rel="stylesheet/scss"></style>

<template> </template>

<script type="text/babel">
export default {
    name: "nav-icon"
};
</script>
